module.exports = __webpack_public_path__ + "img/utenti_smartbook.57ad62e7.png";